module.exports = __webpack_public_path__ + "static/cad-designs20-789e4bfc10536a1bc464ee9c6a16df94.png";